/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameDisplayOrder } from './GameDisplayOrder';
import {
    GameDisplayOrderFromJSON,
    GameDisplayOrderFromJSONTyped,
    GameDisplayOrderToJSON,
} from './GameDisplayOrder';

/**
 * A new ordering for the games listed. A game left out of the request keeps the position it has,
 * so a caller reordering a whole list must send every game in it.
 * @export
 * @interface GameDisplayOrderUpdateRequest
 */
export interface GameDisplayOrderUpdateRequest {
    /**
     * 
     * @type {Array<GameDisplayOrder>}
     * @memberof GameDisplayOrderUpdateRequest
     */
    items: Array<GameDisplayOrder>;
}

/**
 * Check if a given object implements the GameDisplayOrderUpdateRequest interface.
 */
export function instanceOfGameDisplayOrderUpdateRequest(value: object): value is GameDisplayOrderUpdateRequest {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GameDisplayOrderUpdateRequestFromJSON(json: any): GameDisplayOrderUpdateRequest {
    return GameDisplayOrderUpdateRequestFromJSONTyped(json, false);
}

export function GameDisplayOrderUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameDisplayOrderUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GameDisplayOrderFromJSON)),
    };
}

export function GameDisplayOrderUpdateRequestToJSON(value?: GameDisplayOrderUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(GameDisplayOrderToJSON)),
    };
}

